import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LandingNav } from './LandingPage';
import { useTranslation, useLocale } from './contexts/LocaleContext';

export default function NotFound() {
    const t = useTranslation();
    const { locale } = useLocale();
    const navigate = useNavigate();

    return (
        <main className="min-h-screen text-white relative">
            <div className="fixed inset-0 bg-gradient-to-br from-purple-950 via-slate-950 to-black pointer-events-none -z-10" />
            <div className="fixed inset-0 bg-gradient-to-tr from-transparent via-purple-900/20 to-transparent pointer-events-none -z-10" />

            <LandingNav />

            <section className="relative overflow-hidden py-20 md:py-28">
                <div className="relative mx-auto max-w-4xl px-4 text-center">
                    <div className="mb-6 text-6xl md:text-8xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-pink-400 via-fuchsia-400 to-purple-400">
                        404
                    </div>
                    <h1 className="text-2xl md:text-3xl font-bold text-white mb-3">
                        {t.notFound.title}
                    </h1>
                    <p className="text-slate-400 mb-8 md:text-lg">
                        {t.notFound.subtitle}
                    </p>
                    <div className="flex items-center justify-center gap-4">
                        <button
                            onClick={() => navigate(locale === 'cs' ? '/app' : `/${locale}/app`)}
                            className="h-12 px-6 md:px-8 rounded-xl text-white font-semibold inline-flex items-center justify-center bg-pink-600 hover:shadow-pink-500/50 border-0"
                        >
                            {t.notFound.cta}
                        </button>
                    </div>
                </div>
            </section>
        </main>
    );
}


